import React from "react";
import { FilterBar, MultistepFilter } from "@sscs/ui";
import { filterDeleted, filterUpdated, selectFilter, selectFilteredByLink, } from "../../store/issuesSlice";
import { useReportDispatch, useReportSelector } from "../hooks";
import styles from "./issues.module.scss";
import useFilterOptions from "./useFilterOptions";
const Filter = () => {
    const dispatch = useReportDispatch();
    const filters = useReportSelector(selectFilter);
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const filterOptions = useFilterOptions();
    return (React.createElement(FilterBar, { filters: [
            {
                id: "issues",
                minWidth: "0",
                control: (React.createElement(MultistepFilter, { id: "issues-multi-step-filter", className: styles.filter, activeFilters: filters, filterOptions: filterOptions, onFilterSave: (filterName, updatedFilter) => dispatch(filterUpdated({
                        name: filterName,
                        filter: updatedFilter,
                    })), onFilterDelete: (deletedFilterName) => dispatch(filterDeleted(deletedFilterName)), "data-filtered-by-link": filteredByLink })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map